// ======================================================================
// File Name       : DistributionCourseList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Table, InputGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import { Link } from 'react-router-dom';
import TableHead from '../TableHead';
import { WRONG_DISTRIBUTION_DATE_TXT } from '../../utils/index';
import DateTimeWithValidate from '../DateTimeWithValidate';
import DateTimeMinMax from '../DateTimeMinMax';
import { DEFAULT_DATE_FORMAT } from '../../constants/index';

class DistributionCourseList extends React.Component {
  constructor(props) {
    super(props);
    this.validation = this.validation.bind(this);
  }
  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }
  render() {
    this.refsToValidate = [];
    const {
      existedCourseListInfo,
      distributionCourseList,
      handleDateTimeChange,
      handleDeleteDistribution,
    } = this.props;
    const thead = [
      { title: 'コース名', sortBy: null },
      { title: '配布開始日', sortBy: null},
      { title: '配布終了日', sortBy: null},
      { title: '操作', sortBy: null},
    ];
    const onDelete = (event) => {
      const { id } = event.target;
      handleDeleteDistribution(id);
    };

    // table data
    let distributionTableData = null;
    if (distributionCourseList) {
      distributionTableData = distributionCourseList
        .map((distributiontData, index) => {
          const addNewClass = distributiontData.addedNew ?
            'background_new_record' : '';
          return (
            <tr
              key={index}
              className={addNewClass}
            >
              <td>
                {distributiontData.courseName}
              </td>
              <td>
                <DateTimeWithValidate
                  dateFormat={DEFAULT_DATE_FORMAT}
                  value={distributiontData.distributionStartDate}
                  onChange={moment =>
                    handleDateTimeChange(
                      moment,
                      distributiontData.courseSecernId,
                      'distributionStartDate',
                    )}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
                {(distributiontData.distributionStartDate === null ||
                  distributiontData.distributionStartDate === '') &&
                  <p className="alert alert-danger">配布開始日が入力されていません。</p>}
              </td>
              <td>
                <DateTimeWithValidate
                  dateFormat={DEFAULT_DATE_FORMAT}
                  value={distributiontData.distributionEndDate}
                  onChange={moment =>
                    handleDateTimeChange(
                      moment,
                      distributiontData.courseSecernId,
                      'distributionEndDate',
                    )}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                />
                <DateTimeMinMax
                  dateFrom={distributiontData.distributionStartDate}
                  dateTo={distributiontData.distributionEndDate}
                  ref={(ref) => {
                    if (ref) {
                      this.refsToValidate.push(ref);
                    }
                  }}
                  wrongPeriodTxt={WRONG_DISTRIBUTION_DATE_TXT}
                />
                {(distributiontData.distributionEndDate === null ||
                  distributiontData.distributionEndDate === '') &&
                  <p className="alert alert-danger">配布終了日が入力されていません。</p>}
              </td>
              <td className="text-center">
                <i
                  role="button"
                  id={distributiontData.courseSecernId}
                  onClick={onDelete}
                  className="bi bi-trash padding-top-10"
                />
              </td>
            </tr>);
        },
        );
    }

    return (
      <Table striped hover className="margin-top-10">
        <thead>
          <TableHead data={thead} />
        </thead>
        <tbody>
          {distributionTableData}
        </tbody>
      </Table>
    );
  }
}

export default DistributionCourseList;
